import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertRisks } from '../../services/AlertsService';
import { AlertRisksResponse } from '../../types/Alerts';

function useGetAlertRisks(fleetId: string, query = ''): UseQueryResult<AlertRisksResponse> {
  return useQuery(
    ['alert-risks', fleetId, query],
    async (): Promise<AlertRisksResponse> => getAlertRisks(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetAlertRisks;
